import { render, staticRenderFns } from "./old_share.vue?vue&type=template&id=03d210af&"
import script from "./old_share.vue?vue&type=script&lang=js&"
export * from "./old_share.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports